<template>
    <el-table-column :show-overflow-tooltip="true" :width="width" :prop="prop" :label="label" :formatter="formatRes" :reskey="reskey"></el-table-column>
</template>
<script>
export default {
  name:"EcTableColumn",
  props: {
    reskey: {
      type: String,
      default: ""
    },
    formatter: {
      type: Function,
      default:(row, column, cellValue)=>cellValue
    },
    prop: {
      type: String
    },
    label: {
      type: String
    },
    width: {
      type: [Number, String]
    },
    sortable:{
      type: [Boolean, String],
      default: false
    }
  },
  async created () {
    let reskey = this.reskey
    await this.$ResHelper.getVal(reskey, 0)
  },
  methods: {
    formatRes(row, column, cellValue){
      var _this = this;
      if(_this.reskey){     
         var value =  _this.$ResHelper.getVal(_this.reskey, cellValue);
         return value;
      }
      return cellValue;
    }
  },
  mounted () {
  }

};
</script>



// WEBPACK FOOTER //
// src/components/EcTableColumn/src/tableColumn.vue